<!--
  Notification empty list state component

  <NotificationEmptyState />
-->
<script setup lang="ts">
/* COMPONENTS */
import { useCssBreakpoints } from '@af-lib/vue-ui';

/* CONFIG */
import { t } from '@/config/i18n';

/* UTILS */
const { tabletAndUp } = useCssBreakpoints();
</script>

<template>
  <div
    class="flex h-57.5 flex-col items-center justify-center gap-[16px]"
    :class="{ 'w-115': tabletAndUp }"
  >
    <div class="flex size-14 items-center justify-center rounded-full border border-current text-text-accent-color">
      <FaIcon icon="fat fa-bell-on" class="text-xl" aria-hidden="true" />
    </div>
    <p class="text-body3-light w-62.5 text-center text-text-default">
      {{ t('notifications.empty_state') }}
    </p>
  </div>
</template>
